import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import R from "ramda";
import getDisplayName from "../utils/getDisplayName";
import calculateClearFix from "../utils/calculateClearFix";
import * as actionCreators from "../actions";

const connectApplicationFields = WrappedComponent => {
  class ConnectApplicationFields extends Component {
    handleFieldChange = (name, value, error) => {
      this.props.dispatchUpdateField({ name, value, error });
    };

    handleFieldActions = payload => {
      this.props.dispatchTriggerFieldActions(payload);
    };

    render() {
      const { fieldsList, fields, applyId } = this.props;
      const newFielsList = calculateClearFix(fieldsList, fields);

      return R.addIndex(R.map)((name, index) => {
        if (name === "clearfix") {
          return <div key={index} className="clearfix" />;
        } else if (name === "xs-clearfix") {
          return <div key={index} className="clearfix visible-xs-block" />;
        } else if (name === "sm-clearfix") {
          return <div key={index} className="clearfix hidden-xs" />;
        }
        const field = fields[name];
        return (
          <div key={index} className={field.grid}>
            <WrappedComponent
              field={field}
              applyId={applyId}
              handleFieldChange={this.handleFieldChange}
              handleFieldActions={this.handleFieldActions}
            />
          </div>
        );
      })(newFielsList);
    }
  }

  ConnectApplicationFields.displayName = `ConnectApplicationFields(${getDisplayName(
    WrappedComponent
  )})`;

  ConnectApplicationFields.propTypes = {
    fieldsList: PropTypes.array.isRequired,
    fields: PropTypes.object.isRequired,
    applyId: PropTypes.number.isRequired,
    dispatchTriggerFieldActions: PropTypes.func.isRequired,
    dispatchUpdateField: PropTypes.func.isRequired
  };

  const mapStateToProps = ({ application }) => ({
    fields: application.fields,
    applyId: application.applyId
  });

  const mapDispatchToProps = {
    dispatchTriggerFieldActions: actionCreators.triggerFieldActions,
    dispatchUpdateField: actionCreators.updateField
  };

  return connect(mapStateToProps, mapDispatchToProps)(ConnectApplicationFields);
};

export default connectApplicationFields;
